export default "__VITE_ASSET__BDecOc$3__"